import moment from "moment";
import { InlineRangeCalendar } from "PFComponents/calendar/inline_calendar";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import useFiltersRange from "PFCore/hooks/use_filters_range";
import { FilterWithDefaults, Range } from "PFTypes";
import { RefObject, useEffect, useMemo, useState } from "react";

type ReportingRangeItemProps = {
  onChange: (value: Range) => void;
  filter: FilterWithDefaults & { allowFuture?: boolean };
  error?: string;
  portalRef?: RefObject<HTMLDivElement>;
  disabled?: boolean;
};

export const ReportingRangeItem = ({
  filter,
  onChange,
  error,
  portalRef,
  disabled
}: ReportingRangeItemProps) => {
  const { formatISODate } = useDateFormatter();

  const { pastOptions, futureOptions } = useFiltersRange();
  const [bufferedValue, setBufferedValue] = useState(filter.value as Partial<Range> | undefined);

  useEffect(() => {
    setBufferedValue(filter.value as Partial<Range> | undefined);
  }, [filter.value]);

  const { start, end } = bufferedValue || {};

  const options = useMemo(() => (filter.allowFuture ? futureOptions : pastOptions), []);

  const handleChange = (start, end) => {
    const formattedValue = {
      start: formatISODate(start),
      end: formatISODate(end)
    };
    setBufferedValue(formattedValue);
    onChange(formattedValue);
  };

  return (
    <div style={{ padding: "0px 10px", margin: "0px 10px", position: "relative" }}>
      <InlineRangeCalendar
        startDate={start ? formatISODate(start) : ""}
        minDate={formatISODate(moment().subtract(2, "years"))}
        maxDate={filter?.allowFuture ? formatISODate(moment().add(3, "years")) : formatISODate()}
        endDate={end ? formatISODate(end) : ""}
        label={filter.title}
        required={filter.required}
        style={{ marginLeft: -10 }}
        handleChange={handleChange}
        options={options}
        error={error}
        portalRef={portalRef}
        disabled={disabled}
        letClear={!filter.required}
      />
    </div>
  );
};
